import { MaterialIcons } from "@expo/vector-icons";
import { Button, Icon } from "native-base";
import React, { memo, useEffect, useRef } from "react";
import { FlatList } from "react-native";

import Badge from "@/components/atoms/Badge";

export type BadgeType = {
  _id: string;
  nome: string;
};

type BadgeListProps<T> = {
  list?: T[];
  activeId?: string;
  showsPassButons?: boolean;
  onSelect?: (item: T) => void;
};

const PassButton = ({ iconName, onPress }) => (
  <Button variant="ghost" colorScheme="white" onPress={onPress} rounded="full" shadow="4">
    <Icon as={<MaterialIcons name={iconName} />} color="primary.600" size="md" />
  </Button>
);

const BadgeList = <T extends BadgeType>({
  list,
  activeId,
  showsPassButons = true,
  onSelect,
}: BadgeListProps<T>) => {
  const listRef = useRef<FlatList<T>>();

  useEffect(() => {
    if (list?.length && activeId) {
      const index = list.findIndex((l) => l._id === activeId);
      listRef?.current?.scrollToIndex({
        index,
        animated: true,
      });
    }
  }, [list, activeId, listRef?.current]);

  const goToPrev = () => {
    listRef?.current?.scrollToIndex({
      index: 0,
    });
  };

  const goToNext = () => {
    listRef?.current?.scrollToEnd();
  };

  return (
    <>
      {showsPassButons && <PassButton iconName="arrow-back-ios" onPress={goToPrev} />}
      <FlatList
        ref={listRef}
        data={list}
        horizontal
        showsHorizontalScrollIndicator={false}
        getItemLayout={(data, index) => ({
          length: 120,
          offset: 120 * index - 60,
          index,
        })}
        renderItem={({ item }) => (
          <Badge
            key={item._id}
            label={item.nome}
            active={activeId === item?._id}
            onSelect={() => onSelect(item)}
          />
        )}
      />
      {showsPassButons && <PassButton iconName="arrow-forward-ios" onPress={goToNext} />}
    </>
  );
};

export default memo(BadgeList);
